export class CountryState {
    id: number;
	code: string;
	name: string;
}